import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";
// tslint:disable
export const yammer_praise_gift: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-gift" {...rest}>
      <title>praise-gift</title>
      <ellipse
        transform="rotate(-88.789 75.002 74.998) scale(1.00002)"
        fill="#386CBB"
        cx="75"
        cy="75"
        rx="75"
        ry="75"
      ></ellipse>
      <path fill="#FFC56C" d="M84.7 48.8L74 27.9c-2.5-4.9-9.1-5.7-12.8-1.7-3.5 3.9-2.3 10 2.4 12.3l21.1 10.3z"></path>
      <path fill="#FFC56C" d="M67.6 48.8l10.7-20.9c2.5-4.9 9.1-5.7 12.8-1.7 3.5 3.9 2.3 10-2.4 12.3L67.6 48.8z"></path>
      <path
        fill="#FB7F78"
        d="M102.6 121H49.5c-6.8 0-12.3-5.4-12.6-12.1l-2.1-54.2c-.3-7.2 5.4-13.1 12.6-13.1h57.4c7.2 0 12.9 6 12.6 13.1l-2.1 54.2c-.3 6.8-5.9 12.1-12.7 12.1z"
      ></path>
      <path fill="#FFC56C" d="M116 87H36l-.5-13.7h81.2z"></path>
      <path fill="#FFC56C" d="M69.4 41.4H83v79.1H69.4z"></path>
    </svg>
  );
};
